/**
 * Controls the HTML loading overlay shown during boot.
 * Pure DOM — no WebGL, no GameModule. Used only at init time.
 */
export class LoadingScreen {
  private _bar: HTMLElement;
  private _status: HTMLElement;
  private _root: HTMLElement;

  constructor() {
    this._bar = document.getElementById('loading-bar')!;
    this._status = document.getElementById('loading-status')!;
    this._root = document.getElementById('loading-screen')!;
  }

  /** Macht den LoadingScreen sichtbar (initial per CSS versteckt). */
  show(): void {
    this._root.style.display = 'flex';
  }

  setProgress(percent: number, status: string): void {
    this._bar.style.width = `${percent}%`;
    this._status.textContent = status;
  }

  hide(): void {
    this._root.classList.add('fade-out');
    setTimeout(() => this._root.remove(), 500);
  }

  showError(message: string): void {
    this._bar.style.background = '#f44';
    this._bar.style.width = '100%';
    this._status.textContent = message;
    this._status.style.color = '#f88';
  }
}
